/**
 * NCC: "Hide Filters" / "Show Filters" toggle for the vertical facets sidebar (Figma collection page).
 * The state lives on <html data-ncc-facets-hidden> so it survives the collection section being re-rendered
 * after a filter or sort change, and the label swaps in CSS from the button's data attributes.
 */
const KEY = 'ncc-facets-hidden';

class NccFacetsToggle extends HTMLElement {
  connectedCallback() {
    try {
      if (sessionStorage.getItem(KEY) === '1') document.documentElement.setAttribute('data-ncc-facets-hidden', '');
    } catch (e) {
      /* storage unavailable */
    }
    this.#sync();
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('button')) return;
    const root = document.documentElement;
    const hidden = !root.hasAttribute('data-ncc-facets-hidden');
    root.toggleAttribute('data-ncc-facets-hidden', hidden);
    try {
      sessionStorage.setItem(KEY, hidden ? '1' : '0');
    } catch (e) {
      /* storage unavailable */
    }
    this.#sync();
  };

  #sync() {
    const button = this.querySelector('button');
    if (!button) return;
    const hidden = document.documentElement.hasAttribute('data-ncc-facets-hidden');
    button.setAttribute('aria-expanded', hidden ? 'false' : 'true');
  }
}

if (!customElements.get('ncc-facets-toggle')) {
  customElements.define('ncc-facets-toggle', NccFacetsToggle);
}
